<template>
  <div >
    <canvas id="eipqrcode" v-show="showCode"></canvas>
    <div v-show="!showCode">只有在审批任务丶查看实例丶查看数据报表详情丶编辑报表详情才满足条件生成二维码</div>
  </div>
</template>

<script>
import utils from "@/utils.js";
import { mapState } from "vuex";
import QRCode from "qrcode";
import req from "@/request.js";

export default {
  name: "eip-qrcode",
  props: [],
  data() {
    return {
      QRCodeurl:"",
      showCode:false
    };
  },
  methods: {
    //得到url字符串
    getUrlString(){
     // this.QRCodeurl=req.getContext().front +"/QRCodeForm/" +this.templateKey +"/get?id=" +this.rowId+"&token=" + this.$store.state.login.currentUser.token;
      let query=this.$route.query;
      let params=this.$route.params;
      let path=this.$route.path;
      //查看实例页面
      if(params.instId){
         this.QRCodeurl=req.getContext().mobile+"/inst/"+params.instId;
        this.qrcode();
      }else if(params.taskId){ //审批任务(根据路由的任务ID得到实例id)
        req
        .get(window.context.bpmRunTime + "/runtime/task/v1/" + params.taskId)
        .then(response => {
          this.QRCodeurl=req.getContext().mobile+"/inst/"+response.data.procInstId;
          this.qrcode();
        });
        //报表查看明细页面与编辑页面
      }else if(path.indexOf("/statement/template/form") == 0 && params.action!="add"){
          this.QRCodeurl=req.getContext().front +"/QRCodeForm/" +params.templateKey +"/get?id=" +query.id;
          this.qrcode();
      }else{
          let dom=document.getElementById("eipqrcode");
          let parentNode=dom.parentNode.parentNode.parentNode.parentNode;
          parentNode.style.display="none";
      }

    },
    //生成二维码的Canvas
    qrcode() {
      let msg = document.getElementById("eipqrcode");
      QRCode.toCanvas(msg, this.QRCodeurl, function(error) {
        console.log(error);
      });
      this.showCode=true;
    }
  },
  watch: {},
  computed: {},
  mounted() {
    this.getUrlString();
  },
  created() {}
};
</script>
<style lang="stylus" scoped>
div[aria-invalid='true'] >>> .el-input__inner, div[aria-invalid='true'] >>> .el-input__inner:focus {
  border-color: #f56c6c;
}
</style>
